export function vsMarketTypeKey(marketTypeId: string | number, abbr: boolean = false): string {
  const id = String(marketTypeId);
  return abbr ? `VIRTUAL_SPORTS_MARKET_TYPE_ABBR_${id}` : `VIRTUAL_SPORTS_MARKET_TYPE_${id}`;
}

export function vsOutcomeTypeKey(outcomeTypeId: string | number, abbr: boolean = false): string {
  const id = String(outcomeTypeId);
  return abbr ? `VIRTUAL_SPORTS_OUTCOME_TYPE_ABBR_${id}` : `VIRTUAL_SPORTS_OUTCOME_TYPE_${id}`;
}

